export default __webpack_public_path__ + "static/media/won.0527ce6c.mp3";